import moment from 'moment';
import { jwtDecode } from 'jwt-decode';
/**
 * Service for handling JWT token operations
 */
class TokenService {
    /**
     * Decode JWT token
     * @param token - JWT token
     * @returns Decoded token payload or null if invalid
     */
    decode(token) {
        try {
            return jwtDecode(token);
        }
        catch (error) {
            console.error('Token decode error:', error);
            return null;
        }
    }
    /**
     * Check if token is expired
     * @param token - JWT token
     * @returns True if token is expired
     */
    isExpired(token) {
        try {
            const decoded = this.decode(token);
            if (!decoded?.exp) {
                return true;
            }
            const expiry = moment.utc(decoded.exp * 1000);
            const now = moment.utc();
            return now.isAfter(expiry);
        }
        catch (error) {
            console.error('Token expiry check error:', error);
            return true;
        }
    }
    /**
     * Check if token should be refreshed
     * @param token - JWT token
     * @param thresholdMinutes - Minutes threshold for refresh
     * @returns True if token should be refreshed
     */
    shouldRefresh(token, thresholdMinutes = 60) {
        try {
            const decoded = this.decode(token);
            if (!decoded?.exp) {
                return true;
            }
            const expiry = moment.utc(decoded.exp * 1000);
            const now = moment.utc();
            const minutesLeft = expiry.diff(now, 'minutes');
            return minutesLeft < thresholdMinutes;
        }
        catch (error) {
            console.error('Token refresh check error:', error);
            return true;
        }
    }
    /**
     * Validate both authorization and refresh tokens
     * @param tokens - Object containing authorization and refresh tokens
     * @returns True if both tokens are valid
     */
    validateTokens(tokens) {
        try {
            const { authorization, refresh } = tokens;
            return Boolean(authorization &&
                refresh &&
                this.decode(authorization) &&
                this.decode(refresh));
        }
        catch (error) {
            console.error('Token validation error:', error);
            return false;
        }
    }
}
const tokenService = new TokenService();
export default tokenService;
//# sourceMappingURL=tokenService.js.map